module.exports = __webpack_public_path__ + "img/1.0aaa01f4.png";